enum WorkspaceProjectImpactFrameworkComponentRiskLikelihoodType {
  'Low Likelihood' = 'Low Likelihood',
  'Medium Likelihood' = 'Medium Likelihood',
  'High Likelihood' = 'High Likelihood',
  'Very High Likelihood' = 'Very High Likelihood',
}

export default WorkspaceProjectImpactFrameworkComponentRiskLikelihoodType
